import React, { useState } from 'react';
import { imageConfig } from '../../data/imageConfig';
import './Gallery.css';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [isLoading, setIsLoading] = useState({});

  const handleImageLoad = (index) => {
    setIsLoading(prev => ({
      ...prev,
      [index]: false
    }));
  };

  const handleImageClick = (image, index) => {
    setSelectedImage({ ...image, index });
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  const navigateLightbox = (direction) => {
    if (!selectedImage) return;
    
    const currentIndex = selectedImage.index;
    let newIndex;
    
    if (direction === 'prev') {
      newIndex = currentIndex === 0 ? imageConfig.gallery.length - 1 : currentIndex - 1;
    } else {
      newIndex = currentIndex === imageConfig.gallery.length - 1 ? 0 : currentIndex + 1;
    }
    
    setSelectedImage({ 
      ...imageConfig.gallery[newIndex], 
      index: newIndex 
    });
  };

  return (
    <>
      <div className="gallery">
        <div className="gallery-grid">
          {imageConfig.gallery.map((image, index) => (
            <div 
              key={index}
              className="gallery-item"
              onClick={() => handleImageClick(image, index)}
            >
              <div className="image-container">
                {isLoading[index] !== false && (
                  <div className="image-loading">
                    <div className="loading-placeholder"></div>
                  </div>
                )}
                <img
                  src={image.url}
                  alt={image.alt}
                  className="gallery-image"
                  loading="lazy"
                  onLoad={() => handleImageLoad(index)}
                />
                <div className="image-overlay">
                  <div className="overlay-content">
                    <span className="overlay-text">View Image</span>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className="overlay-icon">
                      <path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </div>
              </div>
              {image.caption && (
                <p className="image-caption">{image.caption}</p>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {selectedImage && (
        <div className="lightbox" onClick={closeLightbox}>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            {/* Close Button */}
            <button 
              className="lightbox-close"
              onClick={closeLightbox}
              aria-label="Close gallery"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>

            {/* Navigation */}
            <button 
              className="lightbox-nav lightbox-nav--prev"
              onClick={() => navigateLightbox('prev')}
              aria-label="Previous image"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>

            <button 
              className="lightbox-nav lightbox-nav--next"
              onClick={() => navigateLightbox('next')}
              aria-label="Next image"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>

            {/* Image */}
            <div className="lightbox-image-container">
              <img
                src={selectedImage.url}
                alt={selectedImage.alt}
                className="lightbox-image"
              />
            </div>

            {/* Caption */}
            {selectedImage.caption && (
              <div className="lightbox-caption">
                <p>{selectedImage.caption}</p>
              </div>
            )}

            {/* Counter */}
            <div className="lightbox-counter">
              {selectedImage.index + 1} / {imageConfig.gallery.length}
            </div>
          </div>

          {/* Backdrop */}
          <div className="lightbox-backdrop"></div>
        </div>
      )}
    </>
  );
};

export default Gallery;